import { useMutation, useQueryClient } from '@tanstack/react-query';
import http from 'helpers/requests';
import { cgToast, notifyError } from 'modules/Common/ui/toast';

export const useUpdateOperatorInstallation = ({ silent = false } = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ installationId, installationData }) => {
      const response = await http.put(
        `/installations/operator/${installationId}`,
        installationData,
      );
      return response.data;
    },
    onSuccess: (_data, variables) => {
      cgToast.success('Success', { description: 'Installation updated successfully' });
      queryClient.invalidateQueries({ queryKey: ['operatorInstallations'] });
      // Also invalidate the single-installation cache so the detail
      // page refetches when the edit modal closes in place. Pre-modal,
      // the edit was a separate route — returning to the detail page
      // remounted useFetchSingleInstallation and refetched naturally.
      // Now that edit is a modal on the same page, no remount happens
      // and stale data lingers without this invalidation.
      if (variables?.installationId) {
        queryClient.invalidateQueries({
          queryKey: ['singleInstallation', variables.installationId],
        });
      }
    },
    // D11: callers that render the failure inline pass { silent: true }.
    onError: silent ? undefined : notifyError,
  });
};
